import { Layout } from '@/components/Layout/Layout';

import { Error } from '../Error/Error';

type Props = {
	title?: string;
	description?: string;
	handleBack?: () => void;
};

export const PageError = ({ title, description, handleBack }: Props) => (
	<Layout displaySearchBar={false} fullHeightMainContent>
		<Error
			title={title}
			description={description}
			handleBack={handleBack}
			customSx={{ root: { pt: '10%' } }}
		/>
	</Layout>
);
